var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc-archive-buttons"},[_c('div',{staticClass:"button-archive",class:{ active: _vm.clicked },attrs:{"title":_vm.description},on:{"click":_vm.archiveButtonClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }